import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { Virtual } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ActionStatus, GamePlayerStatus } from '../../../../../Constants';
import {
    availableLodging,
    clockOutableStaff,
    emptyLodgingCount,
    playersWithAttackableLodging,
    unUpgradedLodgingIndexes
} from '../../../../Game/GamePlayerInfo';
import blank512 from '../../../Common/blank-512x512.png';
import { getFactionTextureUrl, getTextureUrl } from '../../../Common/TextureTools';
import { FateBringsYou } from '../../../Choices/FateBringsYou';

import '../../../Choices/lodging-action.css';
import { ASSETS_URL } from '../../../../../Settings';


export class LodgingPoolSelector extends Component {
    render() {
        return <div id={'pools'} className={'lodging-action-anchor'}>
            <img
                src={`${ASSETS_URL}overlays/LodgingAddOverlay-1080x210.png`}
                alt="action"
                className={'swiper-overlay'}
            />
            <Swiper
                slidesPerView={6}
                spaceBetween={0}
                onClick={this.props.onLodgingPoolClick}  // this is an ADD click
                // className="action-scroller-swiper"
            >
                {this.props.availableLodging.map((faction, index) => {
                    return <SwiperSlide key={`gi-${index}`}
                                        virtualIndex={index}>
                        <img
                            src={getFactionTextureUrl(faction)}
                            alt="lodging"
                            // className={'draft-card-img'}
                        />
                    </SwiperSlide>;
                })}
            </Swiper>
        </div>;

    }
}


class CurrentFate extends Component {
    render() {
        const texture = getTextureUrl(this.props.textureId);
        let fate = Array(this.props.currentFate).fill(texture);
        return <>
            <div className={''}>
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    modules={[ Virtual ]}
                    // className="action-scroller-swiper"
                >
                    {fate.map((texture, targetIndex) => {
                        return <SwiperSlide key={`t-${targetIndex}`}
                                            virtualIndex={targetIndex}>
                            <img
                                src={texture}
                                id="fate-texture"
                                alt="fate-texture"
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>;
                    })}
                </Swiper>
            </div>
        </>;
    }
}



export class LodgingActionTarget extends Component {
    // Manual §7.2.2 target picker, rendered at WAIT_FOR_TARGET_ID
    // BEFORE the Fate Die. Verbatim port of the target swiper block
    // that used to live inside LodgingActionJuice — same Swiper
    // props, same SwiperSlide shape, same TargetingOverlay. Click
    // routes to lodgingCommitTarget (engine persists target then
    // runs the roll inline).
    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
        this.state = {
            targets: [],
        }
    }

    componentDidMount() {
        this.setState({
            targets: this.getTargets(),
        });
    }

    getTargets = () => {
        const targetGamePlayers = playersWithAttackableLodging(
            this.props.gameData,
            this.props.gamePlayerData,
        );
        return targetGamePlayers.map(
            gamePlayer => {
                return {
                    id: gamePlayer.id,
                    seat: gamePlayer.seat,
                    name: gamePlayer.name,
                    src: getFactionTextureUrl(gamePlayer.faction),
                }
            });
    }

    onTargetClick = (swiper) => {
        let index = swiper.clickedIndex;
        if (index < this.state.targets.length) {
            let playerId = this.state.targets[index].id;
            this.api.lodgingCommitTarget(playerId);
        }
    }

    render() {
        if (
            this.props.gamePlayerData.status !== GamePlayerStatus.LODGING_ID ||
            this.props.gamePlayerData.action_status !== ActionStatus.WAIT_FOR_TARGET_ID
        ) return <></>

        return (
            <div className={'lodging-action'}>
                <div id={'targets'} className={'lodging-action-anchor'}>
                    <img
                        src={`${ASSETS_URL}overlays/TargetingOverlay-1080x210.png`}
                        alt="action"
                        className={'swiper-overlay'}
                        style={{opacity: '50%'}}
                    />
                    <Swiper
                        slidesPerView={6}
                        spaceBetween={0}
                        modules={[Virtual]}
                        onClick={this.onTargetClick}  // this is a Target click
                        // className="action-scroller-swiper"
                    >
                    {this.state.targets.map((target, targetIndex) => {
                        return <SwiperSlide key={`t-${targetIndex}`}
                                            virtualIndex={targetIndex}>
                            <img
                                src={target.src}
                                alt="target"
                                title={`Target ${target.name} in Seat ${target.seat}`}
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>
                    })}
                    </Swiper>
                </div>
            </div>
        )
    }
}


export class LodgingActionJuice extends Component {
    STAFF_TEXTURE_ID = 157;
    LODGING_TEXTURE_ID = 72;

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
        this.state = {
            sellableRobots: [],
            soldRobots: [],
            startingFate: 0,
            currentFate: 0,
            texture: getTextureUrl(this.LODGING_TEXTURE_ID),
            textureId: this.LODGING_TEXTURE_ID,
            staffTexture: getTextureUrl(this.STAFF_TEXTURE_ID),
            availableLodging: [],
            isFull: false,
            unUpgraded: []
        }
        /// upgradable available
    }

    componentDidMount() {
        this.setState({
            sellableRobots: clockOutableStaff(this.props.gamePlayerData),
            startingFate: this.props.gamePlayerData.current_fate,
            currentFate: this.props.gamePlayerData.current_fate,
            availableLodging: availableLodging(this.props.gameData),
            isFull: emptyLodgingCount(this.props.gamePlayerData) === 0,
            unUpgraded: unUpgradedLodgingIndexes(this.props.gamePlayerData),
        }, this.showLodgingUpgrades);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if the board has changed, reset.
        if (clockOutableStaff(this.props.gamePlayerData).length >
                (this.state.sellableRobots.length + this.state.soldRobots.length)) {
            this.resetStaff();
        }
    }

    componentWillUnmount() {
        this.clearLodgingUpgrades();
    }

    actionImage = (props) => {
        if (props.texture === this.STAFF_TEXTURE_ID) {
            return this.staffImage(props);
        }

        let isPurchased = (props.index + 1 > this.state.startingFate);

        return <div>
            <img
                src={this.state.texture}
                alt="action"
                // className={'inventory-selector-image'}
            />

            {isPurchased &&
                <div className={'purchased-action-container'}>
                    <div className={'purchased-action-parent'}>
                        <div className={'purchased-action-robot-container'}>
                            <img
                                src={this.state.staffTexture}
                                alt="robot"
                                className={'purchased-action-robot'}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    };

    staffImage = (props) => {
        return <div>
            <img
                src={this.state.staffTexture}
                alt="action"
                // className={'inventory-selector-image'}
            />
        </div>
    };

    onStaffClick = () => {
        let sellableRobots = this.state.sellableRobots;
        let soldRobot = sellableRobots.pop()
        this.setState({
            sellableRobots: sellableRobots,
            soldRobots: [...this.state.soldRobots, soldRobot],
            currentFate: this.state.currentFate + 2,
        },
            this.showLodgingUpgrades);
    }

    resetStaff = () => {
        this.setState({
            sellableRobots: [...clockOutableStaff(this.props.gamePlayerData)],
            soldRobots: [],
            currentFate: this.state.startingFate,
        }, this.showLodgingUpgrades);
    }

    _isSelfTarget = () => {
        // Manual §7.2.2: target was committed BEFORE the roll. Self-
        // target → Supply (add/upgrade own lodging); opponent-target →
        // attack (remove opponent lodging, no add/upgrade UI here).
        const target = this.props.gamePlayerData.current_action_target;
        return target == null || target === this.props.gamePlayerData.id;
    }

    onJuiceBarClick = (swiper) => {
        let index = swiper.clickedIndex;
        const isSelfTarget = this._isSelfTarget();
        const hasReset = this.state.soldRobots.length > 0;
        const hasSkip = this.state.currentFate === 0;
        // Opp-target needs an explicit Commit since the pool/upgrade
        // self-spend affordance is gated off.
        const hasConfirm = !isSelfTarget && this.state.currentFate > 0;

        let prefixIndex = 0;
        if (hasReset) {
            if (index === prefixIndex) return this.resetStaff();
            prefixIndex++;
        }
        if (hasSkip) {
            if (index === prefixIndex) {
                this.api.lodgingJuice(this.state.soldRobots);
                return;
            }
            prefixIndex++;
        }
        if (hasConfirm) {
            if (index === prefixIndex) {
                this.clearLodgingUpgrades();
                this.api.lodgingJuice(this.state.soldRobots);
                return;
            }
            prefixIndex++;
        }

        const dataIndex = index - prefixIndex;
        if (dataIndex < 0) return;
        const item = this.getJuiceBarData()[dataIndex];
        if (item === 157) {  // click robot
            this.onStaffClick();
        }
        // item === 76 (action icon) — no-op, dead historical branch.
    }

    getJuiceBarData = () => {
        let selectors = Array(this.state.currentFate).fill(this.state.textureId);
        let robots = Array(this.state.sellableRobots.length).fill(157);
        return [...selectors, ...robots];
    }

    onLodgingPoolClick = (swiper) => {
        const factionId = this.state.availableLodging[
            swiper.clickedIndex];
        this.api.lodgingFullAction(
            this.state.soldRobots,
            this.props.gamePlayerData.id,
            factionId,
            null
        );
        this.clearLodgingUpgrades();
    }


    onLodgingUpgradeClick = (lodgingGridIndex) => {
        this.api.lodgingFullAction(
            this.state.soldRobots,
            this.props.gamePlayerData.id,
            null,
            lodgingGridIndex
        )
        this.clearLodgingUpgrades();
    }

    showLodgingUpgrades = () => {
        if (this.state.currentFate === 0) return this.clearLodgingUpgrades();
        // Upgrade affordance is a Supply path — only valid when the
        // committed target is self. For opp-target, the engine will
        // apply_attack on commit; highlighting own lodging would
        // mislead the player into thinking they're being asked to
        // upgrade.
        if (!this._isSelfTarget()) return this.clearLodgingUpgrades();
        window.dispatchEvent(
            new CustomEvent('highlight-lodging-event',
                {
                    detail: {
                        indexes: this.state.unUpgraded,
                        callback: this.onLodgingUpgradeClick
                    }
                }));
    }

    clearLodgingUpgrades = () => {
        window.dispatchEvent(new Event('clear-lodging-highlight-event'));
    }

    render() {
        if (
            this.props.gamePlayerData.status !== GamePlayerStatus.LODGING_ID ||
            this.props.gamePlayerData.action_status !== ActionStatus.WAIT_FOR_JUICE
        ) return <></>

        const isSelfTarget = this._isSelfTarget();
        const showConfirm = !isSelfTarget && this.state.currentFate > 0;

        return (
            <div className={'lodging-action'}>
                <FateBringsYou
                    currentFate={this.state.currentFate}
                    factionId={2}
                    type={'Lodging'} />
                <div className={'lodging-action-anchor'} id={'juicer'}>
                    <img
                        src={`${ASSETS_URL}overlays/LodgingJuiceOverlay-1080x210.png`}
                        alt="action"
                        className={'lodging-action-background'}
                    />
                    <div className={'lodging-action-flex'}>
                        <div className={'lodging-action-flex-item'}>
                            <Swiper
                                slidesPerView={6}
                                spaceBetween={0}
                                freeMode={true}
                                grabCursor={true}

                                modules={[Virtual]}

                                onSwiper={(swiper) => {
                                    this.swiper = swiper;
                                }}
                                onClick={this.onJuiceBarClick}
                                // className="action-scroller-swiper"
                            >
                                {this.state.soldRobots.length > 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-reset`}
                                                     virtualIndex={-2}>
                                            <Button variant={'stem'}>Reset</Button>
                                        </SwiperSlide>
                                    </div>
                                }
                                {this.state.currentFate === 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-skip`}
                                                     virtualIndex={-1}>
                                            <Button variant={'stem'}>Skip</Button>
                                        </SwiperSlide>
                                    </div>
                                }
                                {showConfirm &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-confirm`}
                                                     virtualIndex={-3}>
                                            <Button variant={'stem'}>Confirm</Button>
                                        </SwiperSlide>
                                    </div>
                                }
                                {this.getJuiceBarData().map((selector, index) => {
                                    return <SwiperSlide key={`gi-${index}`}
                                                        virtualIndex={index}>
                                        <this.actionImage
                                            texture={selector}
                                            index={index}
                                        />
                                    </SwiperSlide>
                                })}
                                {this.state.currentFate === 0 &&
                                    <div className={'lodging-action-flex-button'}>
                                        <SwiperSlide key={`gi-999`}
                                                     virtualIndex={999}>
                                            <img src={blank512} alt={'blank'}
                                                 className={'blank-image'}
                                            />
                                        </SwiperSlide>
                                    </div>
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
                {/* Manual §7.2.2: pool selector is the Supply affordance —
                    only meaningful when target = self. For opp-target
                    the engine routes commit (lodgingJuice) → apply_attack
                    via the Confirm button in the juice bar above. */}
                {isSelfTarget && this.state.currentFate > 0 && <>
                    {!this.state.isFull &&
                <div id={'pools'} className={'lodging-action-anchor'}>
                    <img
                        src={`${ASSETS_URL}overlays/LodgingAddOverlay-1080x210.png`}
                        alt="action"
                        className={'swiper-overlay'}
                    />
                <Swiper
                    slidesPerView={6}
                    spaceBetween={0}
                    modules={[Virtual]}
                    onClick={this.onLodgingPoolClick}  // this is an ADD click
                    // className="action-scroller-swiper"
                >
                    {this.state.availableLodging.map((faction, index) => {
                        return <SwiperSlide key={`gi-${index}`}
                                            virtualIndex={index}>
                            <img
                                src={getFactionTextureUrl(faction)}
                                alt="lodging"
                                // className={'draft-card-img'}
                            />
                        </SwiperSlide>
                    })}
                </Swiper>
                </div>
                    }
                </>}
            </div>
        )
    }
}


export class AddLodging2d extends Component {


    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }

    componentDidMount() {
        this.highlightUpgradableLodging();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.highlightUpgradableLodging();
    }

    highlightUpgradableLodging = () => {
        window.dispatchEvent(
            new CustomEvent('highlight-lodging-event',
                {
                    detail: {
                        indexes: unUpgradedLodgingIndexes(this.props.gamePlayerData),
                        callback: this.onClick
                    }
                }));
    }

    onClick = (lodgingGridIndex) => {
        window.dispatchEvent(new Event('clear-lodging-highlight-event'));
        this.api.lodgingUpgrade(lodgingGridIndex);
    }

    onLodgingPoolClick = (swiper) => {
        const factionId = this.availableLodging[swiper.clickedIndex];
        // select the pool item.
        window.dispatchEvent(new Event('clear-lodging-highlight-event'));
        // todo: I think this can be a 'Lodging' package.
        this.api.addLodging(factionId);
    }

    render() {
        this.availableLodging = availableLodging(this.props.gameData);
        const currentFate = this.props.gamePlayerData.current_fate;
        return <>
            <LodgingPoolSelector
                availableLodging={this.availableLodging}
                onLodgingPoolClick={this.onLodgingPoolClick}
            />
            {currentFate > 1 && <CurrentFate currentFate={currentFate}
                                             textureId={72}/>
            }
        </>;
    }

}
